import template from './leave-report.html';
import controller from './leave-report.controller';

let leaveReportComponent = {
  restrict: 'E',
  template,
  controller
};

export default leaveReportComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/leave-report/leave-report.component.js